import React from "react";
import { GiClick } from "react-icons/gi";

function AcademicDetails({
  experience: { year, degree, content, college, link },
}) {
  return (
    <div className="entry">
      <div className="title">
        <span>{year}</span>
      </div>
      <div className="body">
        <h4 className="entry-role">{degree}</h4>
        <h6 className="college-name entry-company">
          {link ? (
            <a href={link} target="_blank" rel="noopener noreferrer">
              {college} <GiClick />
            </a>
          ) : (
            <span>{college}</span>
          )}
        </h6>
        {/* <p>{content}</p> */}
      </div>
    </div>
  );
}

export default AcademicDetails;
